import { useUiTranslator } from "../../hooks/useUiTranslator";
import { useEasySession } from "../../providers/easySessionProvider";
import { customPalette } from "../../theme/theme";
import { ErrorType } from "../CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import { selectAllItems } from "../CustomCartIdRouteComponent/storeCart";
import { CustomLineItemAccordion } from "../CustomLineItemAccordion/CustomLineItemAccordion";

import { JSX, useEffect } from "react";

import { VMItemGroups, VMLineItems, VMQuotes } from "@4pace-cpq/core";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export function CustomLineItems({
  lineItems,
  quoteId,
  itemGroupId,
  customerId,
  errorList,
}: {
  lineItems?: VMLineItems[] | null;
  quoteId: VMQuotes["id"];
  customerId?: VMQuotes["customerId"];
  itemGroupId: VMItemGroups["id"];
  errorList?: ErrorType[];
}): 0 | JSX.Element | undefined {
  const t = useUiTranslator();
  const { isLoggedIntoEasy } = useEasySession();
  useEffect(() => {
    let lineItemIds: string[] = [];
    lineItems?.map((lineItem) => {
      lineItemIds.push(lineItem.id);
    });
    selectAllItems(lineItemIds);
  }, [lineItems]);

  return (
    lineItems?.length && (
      <TableContainer component={Paper} sx={{ p: 2, pt: 2, pb: 4, mt: 4 }}>
        <Box display="flex" gap={4} mb={2}>
          <Box display="flex" gap={1} alignItems="baseline">
            <Typography
              variant="body2"
              fontWeight="600"
              color={customPalette.primary.dark}
            >
              ProjectId
            </Typography>
            <Typography
              variant="body1"
              fontWeight="100"
              color={customPalette.primary.dark}
            >
              #{quoteId}
            </Typography>
          </Box>
          {customerId ? (
            <Box display="flex" gap={1}>
              <Typography
                variant="body2"
                fontWeight="600"
                color={customPalette.primary.dark}
              >
                Customer Number
              </Typography>
              <Typography
                variant="body1"
                fontWeight="100"
                color={customPalette.primary.dark}
              >
                #{quoteId}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
        </Box>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {errorList && errorList.length > 0 && (
                <TableCell align="center">
                  <Typography variant="caption"></Typography>
                </TableCell>
              )}
              {isLoggedIntoEasy && (
                <TableCell align="center">
                  <Typography variant="caption">
                    {t("CustomApp:cart.table.header.syncSelect", "Sync")}
                  </Typography>
                </TableCell>
              )}
              <TableCell>
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.item", "Item")}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.configurationId", "GPS ID")}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.type", "Type")}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.quantity", "Quantity")}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.notes", "Notes")}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.customerId", "ID")}
                </Typography>
              </TableCell>
              {/*    <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>
                <Typography variant="caption">
                  {t("CustomApp:cart.table.header.priceIndicator")}
                </Typography>
              </TableCell> */}
              {/* {isLoggedIntoEasy && (
                <TableCell align="left">
                  <Typography variant="caption">
                    {t("CustomApp:cart.table.header.status")}
                  </Typography>
                </TableCell>
              )} */}
              <TableCell align="right" colSpan={2}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lineItems?.map((lineItem, idx) => {
              const error = errorList?.find((error) => {
                return error.applicationProductId === lineItem.id;
              });

              return (
                <CustomLineItemAccordion
                  key={lineItem.id}
                  lineItem={lineItem}
                  quoteId={quoteId}
                  itemGroupId={itemGroupId}
                  idx={idx}
                  error={error}
                  errorList={errorList}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
}
